import { FormControl } from '@angular/forms'

/**
 * Von PAUtil.getGeocoderEventAddress zerlegte Mapbox-Adresse.
 * Bewusst als eigenes Interface und nicht als Import aus dem Planungsassistenten,
 * damit dieser Helper nicht von PA-Code abhängt.
 */
export interface ParsedGeocoderAddress {
  country: string
  region: string
  city: string
  post_code: string
  street: string
  street_no: string
  center: number[]
}

/** Formularfelder eines Adressblocks. lat/lng nur dort, wo Koordinaten gepflegt werden. */
export interface GeocoderAddressControls {
  country: FormControl<string>
  state: FormControl<string>
  city: FormControl<string>
  zip: FormControl<string>
  street: FormControl<string>
  lat?: FormControl<number>
  lng?: FormControl<number>
}

/**
 * Übernimmt ein Geocoder-Ergebnis in einen Adressblock.
 *
 * Die Adressblöcke (Adresse, Firmenadresse) unterscheiden sich nur in den
 * Control-Namen — deshalb eine Funktion mit Feldzuordnung statt einer Kopie
 * pro Block und Maske. Die Felder sind im Formular gesperrt und werden
 * ausschließlich hierüber gefüllt, darum jeweils markAsTouched +
 * updateValueAndValidity.
 */
export function applyGeocoderAddress(address: ParsedGeocoderAddress, controls: GeocoderAddressControls): void {
  setControl(controls.country, address.country)
  setControl(controls.state, address.region)
  setControl(controls.city, address.city)
  setControl(controls.zip, address.post_code)
  setControl(controls.street, `${address.street} ${address.street_no}`)
  setControl(controls.lat, address.center[1])
  setControl(controls.lng, address.center[0])
}

function setControl<T>(control: FormControl<T> | undefined, value: T): void {
  if (!control) return

  control.setValue(value)
  control.markAsTouched()
  control.updateValueAndValidity()
}
